import React from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './routes/AppRoutes'
import { auth0Config } from '../infrastructure/auth0/auth0Config'
import { setFaviconFromEnv } from './helpers/favicon'

const App = () => {
  setFaviconFromEnv()
  return (
    <Auth0Provider {...auth0Config}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Auth0Provider>
  )
}

export default App
